export default {
  tooltip_title: 'Click pentru copiere',
  success: 'Copiat!',
};
